<form-input #search
            [control]="queryField"
            [required]="required"
            [autoComplete]="auto"
            [label]="label"
            [placeholder]="placeholder"
            [minLength]="3"
            [maxLength]="128"
            [suffixButton]="allowManualClear ? 'clear' : undefined"
            [suffixAction]="allowManualClear ? manualClear : undefined">

  <mat-autocomplete #auto="matAutocomplete"
                    [displayWith]="displayWith"
                    (optionSelected)="optionSelected($event)">
    <mat-option *ngIf="dataLoading" class="progress-indicator">
      <mat-spinner diameter="30" color="primary"></mat-spinner>
    </mat-option>

    <ng-container *ngIf="!dataLoading">
      <mat-option *ngFor="let item of foundItems" [value]="item" [class.option-small-text]="fitText">
        {{displayWith(item)}}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</form-input>
